import { render } from "./ListeAnneeAcademiquePage.vue?vue&type=template&id=4c388936&ts=true"
import script from "./ListeAnneeAcademiquePage.vue?vue&type=script&lang=ts"
export * from "./ListeAnneeAcademiquePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__